@if(currentView === views.Home) {
  <div class="container">
    <button (click)="selectView(views.Configuration)" class="request-button">Ver configuración de Tokens</button>

    <button (click)="rotatePassword()" class="request-button">Editar contraseña de firma de Tokens</button>
  </div>

  <div class="container">
    <button (click)="revokePassword()" class="request-button">Revocar antigua contraseña de firma de Tokens</button>
  </div>
}

<!-- Vista de detalles y editar configuración de Tokens -->
@if(currentView === views.Configuration || currentView === views.EditConfiguration) {
  @if(!!tokensCfg) {
    <div class="configuration-container">
      <h4>{{currentView === views.Configuration ? 'Detalles de' : 'Editando'}} configuración de Tokens</h4>

      <div class="info-container">
        <div class="left-column">
          <p>Contraseña: {{tokensCfg.tokenPassword !== '' ? (showPassword ? tokensCfg.tokenPassword : '****') : ''}}</p>
          <p>Id de contraseña: {{tokensCfg.tokenPasswordId !== 0 ? tokensCfg.tokenPasswordId : ''}}</p>
          <p>Fecha de contraseña: {{tokensCfg.fechaTokenPassword | date:'dd/MM/yyyy HH:mm:ss'}}</p>
          <p>Contraseña antigua: {{tokensCfg.tokenPasswordOld ? (showPassword ? tokensCfg.tokenPasswordOld : '****' ) : ''}}</p>
          <p>Id de contraseña antigua: {{tokensCfg.tokenPasswordOldId ? tokensCfg.tokenPasswordOldId : ''}}</p>
        </div>

        <div class="right-column">
          <P class="settings-text">Configuración: </P>

          <div class="configuration">
            <p>Minutos de validez de tokens de usuario: </p>
            <input type="number" [(ngModel)]="tokensCfg.settings.tokenUsuarioMinutes"
              [readOnly]="currentView === views.Configuration" placeholder="Minutos">
          </div>

          <div class="configuration">
            <p>Horas de validez de los tokens de M2M: </p>
            <input type="number" [(ngModel)]="tokensCfg.settings.tokenM2MHours"
              [readOnly]="currentView === views.Configuration" placeholder="Horas">
          </div>

          <div class="configuration">
            <p>Horas de validez de los tokens de cliente: </p>
            <input type="number" [(ngModel)]="tokensCfg.settings.tokenClienteHours"
              [readOnly]="currentView === views.Configuration" placeholder="Horas">
          </div>

          <div class="configuration">
            <p>Días de validez de los tokens de refresco de usuario: </p>
            <input type="number" [(ngModel)]="tokensCfg.settings.refreshTokenUsuarioDays"
              [readOnly]="currentView === views.Configuration" placeholder="Días">
          </div>

          <div class="configuration">
            <p>Minutos de validez de tokens de preautentificación: </p>
            <input type="number" [(ngModel)]="tokensCfg.settings.tokenPreAuthMinutes"
              [readOnly]="currentView === views.Configuration" placeholder="Minutos">
          </div>
        </div>
      </div>

      <div class="edit-buttons">
        <button class="button button-colors" (click)="currentView === views.Configuration ? selectView(views.Home) : selectView(views.Configuration, true)">Volver</button>

        <button class="button button-colors" (click)="changeShowPassword()">{{showPassword ? 'Ocultar' : 'Mostrar'}} contraseñas</button>

        <button class="button button-colors"
          (click)="currentView === views.Configuration ? selectView(views.EditConfiguration) : editConfiguration()"
          [disabled]="!globalService.editing">
          {{currentView === views.Configuration ? 'Editar' : 'Confirmar'}}
        </button>
      </div>
    </div>
  }
}